import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { RentActions } from 'src/app/common/store/actions/rent.actions';

import { BookingDialogComponent } from '../booking-dialog/booking-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder, FormsModule } from '@angular/forms';
import { selectAllBookings } from 'src/app/common/store/state/app.state';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { BookingStatus, BookingAction, RentBasicData } from '../../constants/rent-basic-data';
import { Booking } from '../../models/booking.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'app-bookings',
    templateUrl: './bookings.component.html',
    styleUrls: ['./bookings.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule]
})
export class BookingsComponent {

  //@Input() car: Car = new Car();
  //@Input() newBookingCount: number = 0;

  @Input() objectSource: ObjectSource = ObjectSource.DEALER;
  @Input() offerId: string = "";
  @Input() enableNew: boolean = false;
  
  bookings$: Observable<Booking[]>;
  bookings: Booking[] = [];

  BookingStatus = BookingStatus;
  ObjectSource = ObjectSource

  BookingAction = BookingAction;
  bookingActionItems = RentBasicData.bookingActionItems

  openNewDialog$:BehaviorSubject<number>;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder) {

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.openNewDialog$ = new BehaviorSubject<number>(0);

      this.bookings$ = this.store.select(selectAllBookings(this.objectSource, this.offerId))
    
    }
    
  ngOnInit(): void {

    this.bookings$ = this.store.select(selectAllBookings(this.objectSource, this.offerId))
          
    this.bookings$.subscribe(
      (convs: Booking[]) => this.bookings = convs
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    //if(this.newBookingCount > 0){
     // this.openBookingDialog(this.car.id, undefined)
    //}
    
  }


  /*

  openBookingDialog(carId: string, prop?: Booking): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let booking: Booking;

    if(prop !== undefined){
      booking = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
    }else{
      booking = new Booking();
      booking.carId = carId;
      console.log('hello 2')
    }

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: booking
    });
    
    dialogRef.afterClosed().subscribe((result: Booking) => {

      //console.log('helloo = '+JSON.stringify(result));
      if(result != undefined ){

        //console.log('New booking = '+result.status+ " date = "+result.bookingDate+ " car Id = "+JSON.stringify(result));
        if(!(result.id > 0)){
          console.log('new')
          this.store.dispatch(RentActions.bookingNewSubmit ( { booking: result }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(RentActions.bookingUpdateSubmit ( { updatedBooking: result }));          
          return;
        } 
      }  
    });
  }
  */

  openBookingDialog(bookingId: number, bookingAction?: BookingAction): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offerId, bookingId, CarBusinessLine.RENT );

    objectData.objectAction = bookingAction;

    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: objectData
    });
  }
  
  updateBookingStatus(bookingId: number, status: BookingStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(RentActions.bookingStatusUpdateSubmit ( { bookingId: bookingId, status: status, objectSource: this.objectSource }));

  }

  executeAction(booking: Booking, action: BookingAction){
      
    if( [BookingAction.EDIT, BookingAction.EDIT_MODIF, BookingAction.COMPLETE].includes(action) ){
      this.openBookingDialog(booking.id, action )
    }
    else{
      this.store.dispatch(RentActions.bookingActionSubmit ( { bookingAction: action, booking: booking, objectSource: this.objectSource }));  
    }
  }

  onSelectedDatesChange(event: any){
    console.log('hellooo '+event.value);
    
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDate(dt);
  }

}
